import React, { memo, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Theme as StyledTheme } from '@cashfree-intl/coherent';
import { makeSelectEnv } from 'containers/MainLayout/selectors';
import { useSelector } from 'react-redux';
import { appSelector } from 'containers/App/selectors';
import { useSearchParams } from 'react-router-dom';

import {
  isICICIDashboard,
  isLKDashboard,
  isIDFCDashboard,
  isAxisDashboard,
} from '../../utils/common';

import designTokens from '../../utils/designTokens';
import {
  ICICIMERCHANT,
  LENDINGKARTMERCHANT,
  IDFCMERCHANT,
  AXISEASYPAYPLUS,
  IMPORTS_TEST_MERCHANT,
  IMPORTS_PROD_MERCHANT,
} from '../../utils/constants';
import { DashboardClassNames, Environment } from './constants';

function Theme({ children }) {
  const loadState = useSelector(makeSelectEnv());
  const { featureFlags = {} } = useSelector(appSelector()) || {};
  const [searchParams] = useSearchParams();
  const urlEnv = searchParams.get('env');

  const theme = useMemo(() => {
    if (isICICIDashboard()) {
      return designTokens[ICICIMERCHANT];
    }
    if (isLKDashboard()) {
      return designTokens[LENDINGKARTMERCHANT];
    }
    if (isIDFCDashboard()) {
      return designTokens[IDFCMERCHANT];
    }
    if (isAxisDashboard()) {
      return designTokens[AXISEASYPAYPLUS];
    }

    if (
      featureFlags.isMerchantImportEnabled &&
      (loadState
        ? [Environment.TEST, Environment.SANDBOX].includes(loadState)
        : [Environment.TEST, Environment.SANDBOX].includes(urlEnv))
    ) {
      return designTokens[IMPORTS_TEST_MERCHANT];
    }

    if (
      featureFlags.isMerchantImportEnabled &&
      (loadState ? loadState === Environment.PROD : urlEnv === Environment.PROD)
    ) {
      return designTokens[IMPORTS_PROD_MERCHANT];
    }

    return null;
  }, [loadState, featureFlags, searchParams, urlEnv]);

  useEffect(() => {
    let className = DashboardClassNames.DEFAULT;
    if (isICICIDashboard()) className = DashboardClassNames.ICICIMERCHANT;
    else if (isLKDashboard()) className = DashboardClassNames.LK;
    else if (isIDFCDashboard()) className = DashboardClassNames.IDFC;
    else if (isAxisDashboard()) className = DashboardClassNames.AXIS;

    document.querySelector('html').className = className;
  }, [searchParams, urlEnv]);

  return <StyledTheme theme={theme}>{children}</StyledTheme>;
}

Theme.propTypes = {
  children: PropTypes.node.isRequired,
};

export default memo(Theme);
